import { fetchWrapper } from "../utils/fetch-wrapper";

const chatbotService = {
  post,
};

function post(data) {
  return fetchWrapper.post(`chatbot/question`, data);
}

export default chatbotService;
